import { render, staticRenderFns } from "./konfortify-banner.vue?vue&type=template&id=5dc883c6&scoped=true&"
import script from "./konfortify-banner.vue?vue&type=script&lang=js&"
export * from "./konfortify-banner.vue?vue&type=script&lang=js&"
import style0 from "./konfortify-banner.vue?vue&type=style&index=0&id=5dc883c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc883c6",
  null
  
)

export default component.exports